import lootOptions from '../lootOptions';
import gameSettings from '../gameSettings';

const lootObjectsSettingsByType = {
    // [lootOptions.GOOD]: {
    //     spaceForIntersectionPt: {
    //         x: 0.4,
    //         y: 1
    //     }
    // },
    [lootOptions.BAD_TREE_LEFT]: {
        startPoint: {
            x: 0,
            y: gameSettings.roadHeightPx,
            scale: 0.3
        },
        startPointPt: {
            x: 0,
            y: gameSettings.roadHeightPx + 5,
            scale: 0.1
        },
        endPoint: {
            x: -500,
            y: 260,
            scale: 1.1
        },
        endPointPt: {
            x: -300,
            y: 80,
            scale: 1.1
        },
        powRelativeFromScale: false,
        maxOffsetByXPx: null,
        maxOffsetByXPtPx: null,
        spaceForIntersection: {
            x: 11
        },
        spaceForIntersectionPt: {
            x: 4.5
        }
    },
    [lootOptions.BAD_TREE_RIGHT]: {
        startPoint: {
            x: 0,
            y: gameSettings.roadHeightPx,
            scale: 0.3
        },
        startPointPt: {
            x: 0,
            y: gameSettings.roadHeightPx + 5,
            scale: 0.1
        },
        endPoint: {
            x: 500,
            y: 260,
            scale: 1.1
        },
        endPointPt: {
            x: 300,
            y: 80,
            scale: 1
        },
        powRelativeFromScale: false,
        maxOffsetByXPx: null,
        maxOffsetByXPtPx: null,
        spaceForIntersection: {
            x: 11
        },
        spaceForIntersectionPt: {
            x: 4.5
        }
    },
    [lootOptions.BAD_POLICE]: {
        spaceForIntersection: {
            x: 7
        },
        spaceForIntersectionPt: {
            x: 2.5
        }
    },
    [lootOptions.BAD_HOTDOG]: {
        spaceForIntersection: {
            x: 4
        },
        spaceForIntersectionPt: {
            x: 2
        }
    },
    [lootOptions.BAD_LOG]: {
        spaceForIntersection: {
            x: 3
        },
        spaceForIntersectionPt: {
            x: 2
        }
    },
    [lootOptions.BAD_ROADBLOCK]: {
        spaceForIntersection: {
            x: 3
        },
        spaceForIntersectionPt: {
            x: 2
        }
    },
    [lootOptions.BAD_HOLE]: {
        spaceForIntersection: {
            x: 3
        },
        spaceForIntersectionPt: {
            x: 1.95
        }
    },
    [lootOptions.BAD_SEWERAGE]: {
        spaceForIntersection: {
            x: 3
        },
        spaceForIntersectionPt: {
            x: 2
        }
    }
};

export default lootObjectsSettingsByType;
